import _sfc_main from "./BuyBoxShipUrgency2.mjs";
/* empty css                    */
import _export_sfc from "../../../../_virtual/_plugin-vue_export-helper.mjs";
const BuyBoxShipUrgency = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-0e9d6ba9"]]);
export {
  BuyBoxShipUrgency as default
};
//# sourceMappingURL=BuyBoxShipUrgency.mjs.map
